import { render, staticRenderFns } from "./RadioSelectGroup.vue?vue&type=template&id=1bcbca34&scoped=true&"
import script from "./RadioSelectGroup.vue?vue&type=script&lang=ts&"
export * from "./RadioSelectGroup.vue?vue&type=script&lang=ts&"
import style0 from "./RadioSelectGroup.vue?vue&type=style&index=0&id=1bcbca34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcbca34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
